module.exports = __webpack_public_path__ + "static/cassidy-3213b98221d4a3f8d279edc9f59a2bf8.jpg";